<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap; align-items: baseline">
      <div class="search_list">
        <div class="text">状态:</div>
        <Select
          v-model="parameter.state"
          class="select"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
        >
          <Option value="0">禁用</Option>
          <Option value="1">正常</Option>
        </Select>
      </div>
      <Button
        style="margin-right: 15px"
        @click="
          upData = {};
          showConfig = true;
          title = '添加';
        "
        type="primary"
        >添加</Button
      >
    </div>

    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="state">
        <span v-if="row.state == 0">禁用</span>
        <span v-if="row.state == 1">正常</span>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            showConfig = true;
            title = '修改';
          "
          type="primary"
          >修改</Button
        >
        <Button
          style="margin-left: 10px"
          @click="
            upData = row;
            UserGroupUserList();
            showConfig = true;
            title = '用户';
          "
          type="primary"
          >用户</Button
        >
        <Button
          style="margin-left: 10px"
          @click="
            title = '删除';
            upData = row;
            showConfig = true;
          "
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal width="1200" @on-ok="config1" v-model="showConfig1" :title="title1">
      <div v-if="title1 == '添加用户'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>手机号:</div>
          <div>
            <Input
              v-model="upData1.phone"
              placeholder="手机号"
              style="width: 300px"
            />
          </div>
        </div>
      </div>
      <div v-if="title1 == '删除用户'">删除</div>
    </Modal>
    <Modal width="1200" @on-ok="config" v-model="showConfig" :title="title">
      <div v-if="title == '删除'">删除</div>
      <div v-if="title == '用户'">
        <Button
          style="margin-right: 15px"
          @click="
            upData1 = {};
            showConfig1 = true;
            title1 = '添加用户';
          "
          type="primary"
          >添加用户</Button
        >
        <Table
          border
          class="table_style"
          :columns="columns1"
          :data="GroupUserList.list"
          :highlight-row="true"
        >
          <template slot-scope="{ row, index }" slot="state">
            <span v-if="row.state == 0">禁用</span>
            <span v-if="row.state == 1">正常</span>
          </template>
          <template slot-scope="{ row, index }" slot="config">
            <Button
              style="margin-left: 10px"
              @click="
                title1= '删除用户';
                upData1 = row;
                showConfig1 = true;
              "
              type="primary"
              >删除用户</Button
            >
          </template>
        </Table>
        <Page :total="GroupUserList.total" @on-change="switchover1" />
      </div>
      <div v-if="title == '添加' || title == '修改'">
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>名称:</div>
          <div>
            <Input
              v-model="upData.name"
              placeholder="名称"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态：</div>
          <div>
            <RadioGroup v-model="upData.state">
              <Radio :label="0">禁用</Radio>
              <Radio :label="1">正常</Radio>
            </RadioGroup>
          </div>
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      parameter: { pageNow: 1 },
      pageNow: 1,
      showConfig1: false,
      showConfig: false,
      userList: { list: [] },
      GroupUserList: { list: [] },
      upData: {},
      upData1: {},
      title1: "",
      title: "",
      columns1: [
        {
          title: "主键",
          align: "center",
          key: "id",
          className: "fontcolor",
        },
        {
          title: "用户手机号",
          align: "center",
          key: "phone",
          className: "fontcolor",
        },
        {
          title: "分组id",
          align: "center",
          key: "groupId",
          className: "fontcolor",
        },
        {
          title: "操作",
          align: "center",
          className: "fontcolor",
          slot: "config",
          fixed: "right",
        },
      ],
      columns: [
        {
          title: "主键",
          align: "center",
          key: "id",
          className: "fontcolor",
        },
        {
          title: "名称",
          align: "center",
          className: "fontcolor",
          key: "name",
        },

        {
          title: "状态",
          align: "center",
          className: "fontcolor",
          slot: "state",
        },
        {
          title: "创建时间",
          align: "center",
          className: "fontcolor",
          key: "createTime",
        },
        {
          title: "修改时间",
          align: "center",
          className: "fontcolor",
          key: "modifyTime",
        },
        {
          title: "操作",
          align: "center",
          className: "fontcolor",
          slot: "config",
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    this.getData();

    if (localStorage.getItem("role") == "管理员") {
      this.columns.pop();
    }
  },
  methods: {
    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },
    switchover1(pageNow) {
      this.pageNow = pageNow;
      this.UserGroupUserList();
    },
    UserGroupUserList() {
      api
        .UserGroupUserList({ pageNow: this.pageNow, groupId: this.upData.id })
        .then((res) => {
          this.GroupUserList = res.body.data;
        });
    },
    config1() {
      if (this.title1 == "添加用户") {
        api.UserGroupUseradd(this.upData.id, this.upData1.phone).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.UserGroupUserList();
        });
      }
      if (this.title1 == "删除用户") {
        api.UserGroupUserdel(this.upData.id, this.upData1.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.UserGroupUserList();
        });
      }
    },
    config() {
      if (this.upData.id) {
        if (this.title == "删除") {
          api.UserGroupDel(this.upData.id).then((res) => {
            if (res.body.status) {
              this.$Message.info(res.body.message);
            }
            this.getData();
          });
        } else {
          api.UserGroupEdit(this.upData).then((res) => {
            if (res.body.status) {
              this.$Message.info(res.body.message);
            }
            this.getData();
          });
        }
      } else {
        api.UserGroupAdd(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },
    getData() {
      api.UserGroupQueryList(this.parameter).then((res) => {
        this.userList = res.body.data;
      });
    },
  },
};
</script>

<style scoped>
</style>